// @ts-nocheck
import axios from 'axios';
import { useGlobalApi } from 'mir-utils/api-tools';
import * as Types from './types';

/**
 * @description Получить версию продукта с брендовой информацией
 */
export const useGetApiV3Version = (interval?: number, untilSuccess?: boolean,  urlFromParam?: string) => {
  const finalUrl = urlFromParam ?? `/api/v3/version`;
  const [result] = useGlobalApi<Types.Version>(finalUrl, interval, untilSuccess);
  return [result];
};
